import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { Img } from 'components/img/Img';
import { Box, GridList, H2, List, ListItem, RowBox, Section, Span, Text } from 'styles';
import { Button, Checkbox, FileBox, Icon, InputLabel, Radio, FormikInput, FormikTextarea,
  Alert, Confirm
} from 'components';

import inquireService from 'services/inquire-service';
import { getFileSizeString } from 'utils';
import { Spinner } from 'components/Spinner';
import * as S from './LandingStyle';
import { Section1 } from './Section1';
import { Section2 } from './Section2';
import { Section3 } from './Section3';
import { Section4 } from './Section4';
import { Section5 } from './Section5';
import { Section6 } from './Section6';
import { Section7 } from './Section7';
import { Section8 } from './Section8';
import { Section9 } from './Section9';
import { Section10 } from './Section10';
import { Faq } from './Faq';

export function Landing({ sectionRefs }) {
  const PACKAGES = [
    {value: '1', name: 'Ad Survey', desc: '10문항 이하'},
    {value: '2', name: 'Quick Survey', desc: '11~20문항'},
    {value: '3', name: 'Premium Survey', desc: '21~30문항'}
  ];

  const RESPONSES = [
    {value: '1', name: '응답수 500명'},
    {value: '2', name: '응답수 1,000명'},
  ]

  const { t } = useTranslation();

  const [files, setFiles] = useState([]);
  const [showFileError, setShowFileError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showAgree1Error, setShowAgree1Error] = useState(false);
  const [alert, setAlert] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [showTopBanner, setShowTopBanner] = useState(true);

  const schema = yup.object().shape({
    name: yup.string().required(t('validation.required.entry')),
    company: yup.string(),
    phone: yup.string()
      .matches(/^\d+$/, t('validation.numbers.only')),
    email: yup.string()
      .required(t('validation.required.entry'))
      .email(t('validation.valid.email.address')),
    introduce: yup.string(),
    question: yup.string()
      .required(t('validation.required.entry'))
  });

  const handleOnSubmit = async (values) => {
    console.log(values);

    // if (file === null) {
    //   setShowFileError(true);
    // } else {
    //   setShowFileError(false)
    // }

    // if (!formik.isValid || file === null) {
    //   return
    // }

    if (!agree.agree1) {
      setShowAgree1Error(true);
    } else {
      setShowAgree1Error(false);
    }

    if (!formik.isValid || !agree.agree1) {
      return
    }

    const doSubmit = async () => {
      let response = null;

      setIsSubmitting(true)

      try {
        const formData = new FormData();

        files.forEach((f) => {
          formData.append("file", f, f.name);
        });

        formData.append("name", values.name);
        formData.append("company", values.company);
        formData.append("phone", values.phone);
        formData.append("email", values.email);
        formData.append("introduce", values.introduce);
        formData.append("question", values.question);
        formData.append("package", values.package);
        formData.append("response", values.response);

        const selectedPackage = PACKAGES.filter((p) => p.value === values.package);
        if (selectedPackage && selectedPackage.length === 1) {
          formData.append("packageName", `${selectedPackage[0].name}`);
        }

        const selectedResponse = RESPONSES.filter((p) => p.value === values.response);
        if (selectedResponse && selectedResponse.length === 1) {
          formData.append("responseName", `${selectedResponse[0].name}`);
        }

        response = await inquireService.sendInquiry(formData);

        console.log(response)

        if (response && response.success === true) {
          setAlert({content: t('inquiry.complete.message'), onClick: () => {
            setAlert()
          }});
          formik.resetForm();
          setAgree({
            agree1: false,
            agree2: false
          })
          setFiles([]);
        } else {
          setAlert({content: t('common.error.server'), onClick: () => {
            setAlert()
          }});
        }
      } catch(e) {
        console.error(e);
        setShowErrorModal(true);
        setAlert({content: t('common.error.server'), onClick: () => {
          setAlert()
        }});
      }

      setIsSubmitting(false);
    }

    

    setConfirm({
      content: '문의/의뢰를 요청하시겠습니까?',
      onClick: () => {
        setConfirm(false);
        doSubmit();
      }
    });
  };
  
  const formik = useFormik({
    initialValues: {
      name: '',
      company: '',
      phone: '',
      email: '',
      introduce: '',
      question: '',
      package: null,
      response: null,
    },
    validationSchema: schema,
    onSubmit: handleOnSubmit
  });


  

  // 스크롤 이동
  const setRef = (name) => (element) => {
    sectionRefs.current[name] = element;
  };

  // 개인정보 동의
  const [agree, setAgree] = useState({
    agree1: false,
    agree2: false,
  });
  const agreeOnChange = (name, checked) => {
    setAgree({ ...agree, [name]: checked });
  };
  // 정보 이용 동의 전문보기
  const [views, setViews] = useState([false, false]);

  const toggleAgree = (index) => {
    const newViews = [...views];
    newViews[index] = !newViews[index];
    setViews(newViews);
  };

  return (
    <>
      <S.Main>
        { showTopBanner && 
          <Section>
            <Box $position="relative" $backgroundColor="secondary10" $padding="32px" $mPadding="16px">
              <Box 
                style={{ position: 'absolute', top: '16px', right: '16px', cursor: 'pointer' }}
                onClick={() => setShowTopBanner(false)}
              >
                <Icon name="CloseCircle" />
              </Box>
              <RowBox $gap={32} $mGap={16}  $justifyContent="center" $width="fit-content" $margin="auto">
                <Box $margin="auto">
                  <Img desktopSrc="event" $width="100%" />
                </Box>
                <Box $margin="auto">
                  <Text $type="b20" $mType="b16" $color="gray700">
                    설문 참여하고 리워드 받기
                  </Text>
                  <Text $type="16" $mType="13" $color="gray700">
                    설문에 참여하면 리워드가 자동으로 적립됩니다
                    <br />T 멤버십 가입자라면 통신사와 상관없이 참여할 수 있습니다.</Text>
                </Box>
              </RowBox>
            </Box>
          </Section>
        }
        <Section1 sectionRefs={sectionRefs} />
        <Section2 setRef={setRef('about')}/>
        <Section3 setRef={setRef('process')} />
        <Section4 />
        <Section5 />
        <Section6 />
        <Section7 onClick={() => {
          window.Kakao.Channel.chat({
            channelPublicId: process.env.REACT_APP_KAKAO_CHAT_CHANNEL_ID // Use the ID included in the home URL of Kakao Talk Channel.
          });
        }} />
        <Section8 setRef={setRef('price')} />
        <Section9 />
        <Section
          ref={setRef('request')}
          $padding="80px 40px"
          $mPadding="40px 20px"
          $maxWidth={1600}
          $margin="auto"
          $scrollMarginTop={91}
          $mScrollMarginTop={107}
        >
          <Box $margin="64px 0" $mMargin="32px 0">
            <RowBox $padding="40px" $mPadding="16px 0" $gap={80} $mGap={20} $tFlexDirection="column">
              <Box $minWidth={460} $mMinWidth="100%">
                <H2 $display="none">의뢰하기</H2>
                <Button $type="badge">
                  <Icon name="badgeIcon" />
                  Make a request right now
                </Button>
                <Text $type="b44" $mType="b28" $padding="24px 0 32px">
                  꼭 찾던 설문,
                  <br />N-Survey로
                  <br />만나보세요!
                </Text>
                <Text $type="18" $mType="16" $color="gray600">
                  설문 의뢰부터 결과 분석까지, 전문팀이 빠르게 안내해 드립니다.
                </Text>

                <Box $width="100%"
                  $padding="32px 16px" 
                  $margin="16px 0" 
                  $mMargin="8px 0"
                  $backgroundColor="primary10"
                  $border={{ color: 'gray300' }}
                  $borderRadius="8px"
                >
                  <Text $type="16" $mType="14" $color="gray600">
                    이메일 문의
                  </Text>
                  <a href="mailto:nsurvey@namowebiz.com">
                    <Text $type="b20" $mType="b14" $color="primary700">
                      nsurvey@namowebiz.com
                    </Text>
                  </a>
                </Box>
                <Box $width="100%" 
                  $padding="32px 16px"
                  $margin="16px 0" 
                  $mMargin="8px 0" 
                  $backgroundColor="primary10"
                  $border={{ color: 'gray300' }}
                  $borderRadius="8px"
                >
                  <Text $type="16" $mType="14" $color="gray600">
                    사업자 정보
                  </Text>
                  <Text $type="sb16" $mType="sb14" $color="gray600">
                    나모웹비즈 주식회사  · 215-87-91517
                  </Text>
                  <Text $type="sb16" $mType="sb14" $color="gray600">
                    서울시 송파구 법원로 128 문정역 SK V1 B동 1014호
                  </Text>
                </Box>
              </Box>
              <Box $width="100%" $padding="64px 36px" $mPadding="32px 18px" style={{boxShadow: '0px 4px 40px rgba(0, 0, 0, 0.1)'}}>
                <RowBox $justifyContent="space-between" $alignItems="flex-end" $paddingBottom="20px" style={{borderBottom: '2px solid #51E9C9'}}>
                  <Text $type="b32" $mType="b16">
                  설문 의뢰 신청서
                </Text>
                <Text $type="sb16" $mType="sb14" $color="secondary">
                  * 표시된 항목은 필수 응답입니다.
                </Text>
                </RowBox>
                <GridList $grid={2} $gap={32} $mGap={30} $width="100%" $mGrid={1} $marginTop={40} $mMarginTop={20}>
                  <ListItem>
                    <InputLabel label="의뢰자 성명" htmlFor="name" $invalid={formik.touched.name && formik.errors.name && "error"} require />
                    <FormikInput
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange} onBlur={formik.handleBlur}
                      placeholder="성명을 입력해 주세요"
                      touched={formik.touched.name} invalid={formik.errors.name}
                      clearValue={() => {
                        formik.setFieldValue('name', '', true);
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <InputLabel label="의뢰자 소속" htmlFor="company" $invalid={formik.touched.company && formik.errors.company && "error"}/>
                    <FormikInput
                      name="company"
                      value={formik.values.company}
                      onChange={formik.handleChange} onBlur={formik.handleBlur}
                      placeholder="소속을 입력해 주세요"
                      touched={formik.touched.company} invalid={formik.errors.company}
                      clearValue={() => {
                        formik.setFieldValue('company', '', true);
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <InputLabel label="연락처" htmlFor="tel" $invalid={formik.touched.phone && formik.errors.phone && "error"} require />
                    <FormikInput
                      type="tel"
                      name="phone" 
                      value={formik.values.phone}
                      onChange={formik.handleChange} onBlur={formik.handleBlur}
                      placeholder="숫자만 입력해 주세요"
                      touched={formik.touched.phone} invalid={formik.errors.phone}
                      clearValue={() => {
                        formik.setFieldValue('phone', '', true);
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <InputLabel label="이메일" htmlFor="email" $invalid={formik.touched.email && formik.errors.email && "error"} require />
                    <FormikInput
                      name="email" 
                      value={formik.values.email}
                      onChange={formik.handleChange} onBlur={formik.handleBlur}
                      placeholder="이메일 주소를 입력해주세요"
                      touched={formik.touched.email} invalid={formik.errors.email}
                      clearValue={() => {
                        formik.setFieldValue('email', '', true);
                      }}
                    />
                  </ListItem>
                </GridList>
                <Box $width="100%" $padding="32px 0 0" $mPadding="16px 0 0">
                <List>
                  <ListItem>
                    <InputLabel label="설문에 대해 간략히 소개해 주세요." htmlFor="introduce" require/>
                    <FormikInput
                      name="introduce"
                      value={formik.values.introduce}
                      onChange={formik.handleChange} onBlur={formik.handleBlur}
                      placeholder="설문에 대해 간략히 소개해 주세요."
                      touched={formik.touched.introduce} invalid={formik.errors.introduce}
                      clearValue={() => {
                        formik.setFieldValue('introduce', '', true);
                      }}
                    />
                  </ListItem>
                  <ListItem $marginTop={32}>
                    <InputLabel label="이미 작성한 설문지가 있다면 첨부해 주세요." />
                    <Box>
                      <Button $type="line" $width="100%" style={{ backgroundColor: '#F9FBFF', borderColor: '#E4E7EA' }} onClick={() => {
                        document.getElementById('formFile').click();
                      }}>
                        <RowBox  $alignItems="center" $justifyContent="center" $padding="8px">
                          <Icon name="Add" />
                          <Text $color="gray500">파일 첨부 (Excel, Word, PDF 등)</Text>
                        </RowBox>
                      </Button>
                      <input style={{display: 'none'}} type="file" id="formFile" multiple onChange={(event) => {
                        if (event && event.target && event.target.files && event.target.files.length > 0) {
                          const newFiles = Array.from(event.target.files);
                          setFiles(prev => [...prev, ...newFiles]);
                          setShowFileError(false);
                          event.target.value = '';
                        }
                      }}/>
                    </Box>
                    { files.length > 0 &&
                      <FileBox
                        list={files.map((f) => ({ fileName: f.name, capacity: getFileSizeString(f.size) }))}
                        onDeleteFile={(index) => {
                          setFiles(prev => prev.filter((_, i) => i !== index));
                        }}
                      />
                    }
                  </ListItem>
                  <ListItem $marginTop={32}>
                    <InputLabel label="희망하는 설문 유형을 선택해주세요" require />
                    <GridList $grid={3} $marginTop={17} $gap={16} $mGap={4} $mGrid={1}>
                      {
                        PACKAGES.map((pk) => (
                          <S.GradientItem $checked={formik.values.package === pk.value} key={pk.value} $padding="21px 24px">
                            <Radio name="package" value={pk.value} onChange={() => {
                                  formik.setFieldValue('package', pk.value)
                                }} checked={formik.values.package === pk.value}>
                              <Box>
                                <Text $type="b18" $color="normal">
                                  {pk.name}
                                </Text>
                              </Box>
                            </Radio>
                          </S.GradientItem>
                        ))
                      }
                    </GridList>
                  </ListItem>
                  <ListItem $marginTop={32}>
                    <InputLabel label="희망하는 보장 응답 수" require />
                    <GridList $grid={2} $gap={16} $marginTop={17} $mGrid={1} $mGap={4}>
                      {
                        RESPONSES.map((resp) => (
                          <S.GradientItem $checked={formik.values.response === resp.value} key={resp.value} $padding="21px 24px">
                            <Radio
                              name="response"
                              value={resp.value}
                              onChange={() => {
                                formik.setFieldValue('response', resp.value)
                              }}
                              checked={formik.values.response === resp.value}
                            >
                              <Text $type="b18" $color="normal">
                                {resp.name}
                              </Text>
                            </Radio>
                          </S.GradientItem>
                        ))
                      }
                    </GridList>
                  </ListItem>
                  <ListItem $marginTop={32}>
                    <InputLabel label="더 알고 싶은 사항" htmlFor="question" $invalid={formik.touched.question && formik.errors.question && "error"} />
                    <FormikTextarea
                      name="question"
                      value={formik.values.question}
                      onChange={formik.handleChange} onBlur={formik.handleBlur}
                      placeholder="타겟팅 조건, 일정, 기타 문의사항을 적어주세요"
                      touched={formik.touched.question} invalid={formik.errors.question}
                    />
                  </ListItem>
                </List>
                <Box $padding="32px 0" $mPadding="16px 0">
                  <Box $lineHeight="0">
                    <RowBox $alignItems="center" $gap={8} $mFlexDirection="column">
                      <Checkbox $padding="6px 0" name="agree1" checked={agree.agree1}
                        onChange={(name, checked) => {
                          setAgree({ ...agree, [name]: checked });
                          if (checked) {
                            setShowAgree1Error(false)
                          } else {
                            setShowAgree1Error(true);
                          }
                        }}
                      >
                        <RowBox $mFlexDirection="column" $alignItems="center" $mAlignItems="flex-start">
                          <Text $type="m16" $color="assistive">
                            <Span $type="b16">(필수)&nbsp;</Span>상담 서비스를 제공하기 위한 개인정보 수집 및 이용에
                            동의합니다.&nbsp;
                          </Text>
                          <Text
                            $type="14"
                            $color="secondary900"
                            $textDecoration="underline"
                            $cursor="pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              toggleAgree(0);
                            }}
                          >
                            전문보기
                          </Text>
                          {
                            showAgree1Error && 
                            <Text $type="14" $color="alert">
                              {t('validation.required.entry')}
                            </Text>
                          }
                        </RowBox>
                      </Checkbox>
                    </RowBox>
                    {views[0] && (
                      <Box $marginLeft={38}>
                        <Text $color="supportive" $type="14">
                          1. 수집 항목
                          <br />
                          필수 : 성명, 이메일
                          <br />
                          2. 수집 목적 : 앤써베이 서비스 이용을 위한 상담
                          <br />
                          3. 보유 기간 : 견적 문의일로부터 6개월
                          <br />※ 상담 서비스 제공을 위한 개인정보 수집 및 이용에 동의하지 않은 경우 앤써베이 서비스
                          견적을 제공 받을 수 없게 됩니다.
                        </Text>
                      </Box>
                    )}
                  </Box>
                  <Box $lineHeight="0">
                    <RowBox $alignItems="center" $gap={8} $mFlexDirection="column">
                      <Checkbox name="agree2" checked={agree.agree2} $padding="6px 0" onChange={agreeOnChange}>
                        <RowBox $mFlexDirection="column" $alignItems="center" $mAlignItems="flex-start">
                          <Text $type="m16" $color="assistive">
                            (선택) 마케팅 활용을 위한 개인정보 수집 및 이용에 동의합니다.&nbsp;
                          </Text>
                          <Text
                            $type="14"
                            $color="secondary900"
                            $textDecoration="underline"
                            $cursor="pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              toggleAgree(1);
                            }}
                          >
                            전문보기
                          </Text>
                        </RowBox>
                      </Checkbox>
                    </RowBox>
                    {views[1] && (
                      <Box $marginLeft={38}>
                        <Text $color="supportive" $type="14">
                          1. 수집 항목
                          <br />
                          필수 : 성명, 이메일
                          <br />
                          2. 수집 목적 : 뉴스레터 등 발송 및 맞춤형 마케팅 정보 제공
                          <br />
                          3. 보유 기간 : 구독 취소 등 마케팅 활용에 대한 동의 철회 시점까지
                          <br />※ 마케팅 정보 활용을 위한 개인정보 수집 및 이용에 동의하지 않은 경우 앤써베이 관련
                          소식을 제공 받을 수 없게 됩니다.
                        </Text>
                      </Box>
                    )}
                  </Box>
                </Box>
                { isSubmitting ?
                  <Spinner/>
                  :
                  <Button $type="common" $width="100%" onClick={() => {
                    if (!agree.agree1) {
                      setShowAgree1Error(true);
                    } else {
                      setShowAgree1Error(false);
                    }
        
                    formik.submitForm();
                  }}>
                    <RowBox $gap={8} $alignItems="center" $justifyContent="center">
                      <Text $type="b18" $mType="b14">의뢰 신청하기</Text>
                      <Icon name="arrowRightWhite" />
                    </RowBox>
                  </Button>
                }
              </Box>
              </Box>
            </RowBox>
          </Box>
        </Section>
        <Section10 />
        <Faq setRef={setRef('faq')} />
        {/* <Section $padding="128px 20px" $mPadding="64px 20px" $maxWidth={1600} $margin="auto">
          <Box $lineHeight="0" $width="fit-content" $margin="auto">
            <Img desktopSrc="kakao" mobileSrc="moKakao" $width="100%" />
          </Box>
        </Section> */}
      </S.Main>
      
      <Alert alert={alert} setAlert={setAlert} {...alert} />
      <Confirm confirm={confirm} setConfirm={setConfirm} {...confirm} />
    </>
  );
}
